import { render, staticRenderFns } from "./UserTypeModal.vue?vue&type=template&id=a61348ca"
import script from "./UserTypeModal.vue?vue&type=script&lang=js"
export * from "./UserTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports